export default {"src":"/uk/_next/static/media/mobileChecklistIcon.58f2873c.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};